import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

const mapStateToProps = ({ config: { facebookId, allowIndexing } }) => (
  { facebookId, allowIndexing }
);

const Meta = ({ facebookId, allowIndexing }) => (
  <Helmet
    title="Catalog"
    titleTemplate="%s | Mendeley"
    meta={[
      { name: 'robots', content: allowIndexing ? 'index,follow' : 'noindex' },
      { property: 'fb:app_id', content: facebookId }
    ]}
  />
);

export default connect(mapStateToProps, {})(Meta);



// WEBPACK FOOTER //
// ./src/universal/ui/components/App/Meta.js